"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const useClickListener = (handler, selectorCheck) => {
  (0, _react.useEffect)(() => {
    // Check if selector is passed to function, and selected element exists in DOM. selectorCheck should be a DOM query, like 'document.querySelectorAll(".nav-entry").length > 0'
    // if the element doesn't exist in the DOM we shouldn't add a listener/handler for it onto the app.
    // hopefully this approach results in better performance by not having blank listeners sitting in memory!
    if (selectorCheck && typeof window !== "undefined" && typeof document !== "undefined") {
      document.addEventListener("click", handler);
      return () => {
        document.removeEventListener("click", handler);
      };
    }
  }, [handler, selectorCheck]);
};
var _default = useClickListener;
exports.default = _default;